import { useEffect, useState } from "react";

import { PaddleBillingAdapter } from "../lib/PaddleBillingAdapter";

export const usePaddleBilling = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    PaddleBillingAdapter.getInstance()
      .load()
      .then(() => setIsLoaded(true))
      .catch((err) => setError(err instanceof Error ? err : new Error(String(err))));
  }, []);

  return { isLoaded, error };
};
